
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/html-for-kids",
      function () {
        return require("private-next-pages/courses/html-for-kids.tsx");
      }
    ]);
  